// import GSAP
import gsap from "gsap";

//Initialises the cursor. referenceEl is the element you want the cursor to appear over, use 'body' for the entire webpage!
export const initCursor = (referenceEl = null) => {

	if(referenceEl == null){
		referenceEl = 'body';
	}

	let referenceElement = document.querySelector(referenceEl);

	if(referenceElement){

		let hasMoved = false;
		const cursor = document.querySelector('.c-cursor');

		

		if (cursor) {

			// Setup mousemove event for cursor tracking
			window.addEventListener('mousemove', (e) => {
				// Only show cursor after mouse has moved
				if (!hasMoved) {
					toggleCursor(true); //Turn Cursor on!
					cursor.classList.remove('not-initialized');
					hasMoved = true;
				}

				const xPos = e.clientX - 70;
				const yPos = e.clientY - 70;
				gsap.set(cursor, {
					x: xPos,
					y: yPos,
				});
			});

			let hoveringOverReferenceElement = false;
			//Hide cursor when not hovering over the reference element
			referenceElement.addEventListener('mouseover', () => {
				if(!hoveringOverReferenceElement){
					hoveringOverReferenceElement = true;
					cursor.classList.remove('button-hover');
					toggleCursor(true);
				}
				
			});
			referenceElement.addEventListener('mouseleave', () => {
				hoveringOverReferenceElement = false;
				cursor.classList.add('button-hover');
				toggleCursor(false);
			});


			// Hide cursor when hovering over button
			referenceElement.querySelectorAll('.button').forEach((el) => {
				el.addEventListener('mouseover', () => {
					cursor.classList.add('button-hover');
					toggleCursor(false);
				});
				el.addEventListener('mouseleave', () => {
					cursor.classList.remove('button-hover');
					toggleCursor(true);
				});
			});


			//Disable the cursor if scrolled past the element, as scrolling without moving mouse doesn't fire event
			let elHeight = referenceElement.offsetHeight;
			document.addEventListener('scroll', (event) => {

				window.scrollY;
				let currentElOffset = referenceElement.offsetTop;

				if(window.scrollY > (elHeight) ){
					toggleCursor(false);
				}
			})
		}
	}

	
};




export const toggleCursor = (state) => {

	//State = true 	: turn custom cursor on
	//State = false : remove custom cursor

	if(state){
		document.querySelector('body').classList.add('custom-cursor');
	}else{
		document.querySelector('body').classList.remove('custom-cursor');
	}

}
